/**
 * Shared Clerk <SignIn>/<SignUp> appearance — court-exhibit grammar: squared
 * corners (no radius), token-driven colors, mono-cap primary button. Keeps the
 * embedded Clerk widget visually consistent with the rest of the platform.
 */

export const authClerkAppearance = {
  elements: {
    rootBox: 'w-full',
    card: 'shadow-none border-0 bg-transparent rounded-none',
    headerTitle: 'hidden',
    headerSubtitle: 'hidden',
    socialButtonsBlockButton:
      'rounded-none bg-transparent border border-[var(--color-border)] text-[var(--color-text-secondary)] hover:bg-[var(--color-bg-hover)] transition-colors',
    socialButtonsBlockButtonText: 'font-mono text-xs uppercase tracking-[0.1em]',
    dividerLine: 'bg-[var(--color-border)]',
    dividerText: 'font-mono text-[11px] uppercase tracking-[0.14em] text-[var(--color-text-muted)]',
    formFieldLabel:
      'font-mono text-[11px] uppercase tracking-[0.08em] text-[var(--color-text-secondary)]',
    formFieldInput:
      'rounded-none bg-transparent border-[var(--color-border)] focus:border-[var(--color-text-primary)] focus:ring-0 text-[var(--color-text-primary)]',
    formButtonPrimary:
      'rounded-none bg-[var(--color-brand)] hover:bg-[var(--color-brand-hover)] text-[var(--color-on-brand)] py-3 font-mono text-xs font-semibold uppercase tracking-[0.14em] transition-colors',
    footerActionLink:
      'text-[var(--color-needs-human-text)] hover:text-[var(--color-brand-hover)] font-medium',
    identityPreviewText: 'text-[var(--color-text-secondary)]',
    identityPreviewEditButton: 'text-[var(--color-needs-human-text)]',
    formFieldSuccessText: 'text-[var(--color-verified)]',
    formFieldErrorText: 'text-[var(--color-needs-human-text)]',
    alertText: 'text-[var(--color-text-secondary)]',
    otpCodeFieldInput:
      'rounded-none bg-transparent border-[var(--color-border)] focus:border-[var(--color-text-primary)]',
    formResendCodeLink: 'text-[var(--color-needs-human-text)] hover:text-[var(--color-brand-hover)]',
  },
  layout: {
    socialButtonsPlacement: 'bottom' as const,
    showOptionalFields: false,
  },
};
